import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APIConstants } from '../../../../_config/restapis';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { logger } from '../../../../_helpers/Logger/Logger.class';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ErrModalData, PromptModalData, SuccModalData, ModalData } from '../../../../_helpers/Modals/ModalData';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';

@Injectable()
export class APIDndRegistrationDetails {

    constructor(
        private http: HttpClient,
        private $modal: $ModalManagerService,
        private modal: BsModalService,
        private bnIdle: BnNgIdleService,
        private router: Router,

    ) { }


    public upload(data): Observable<any> {

		
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');


        let a= this.http.post(APIConstants.INVOKE, data, { headers });
        return a;

    }

	public registrationmailsend(mob,refno,dynamic): Observable<any> {
		
       	
         let data = {mobile : mob,rno:refno,dyn:dynamic};         
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');    


        let a= this.http.post(APIConstants.REGMAIL, data,{ headers });  
        return a;

    }
	
    public getSubscriberPreferenceDetails(mobileno): Observable<any> {
        return this.http.get(APIConstants.GETSUBSCRIBERANDPREFERENCEDETAILS+mobileno);

    }

	public downloadPrefFAQ(): Observable<any> {
        return this.http.get(APIConstants.DOWNLOADPREFFAQ);

    }
	
	public getSrvac(mobileno): Observable<any> {
        return this.http.get(APIConstants.GETSRVAC+'/'+mobileno); 

    }
   
}
